import { request } from "utils/api";
import { RequestResponse } from "utils/base_api";

export function index(): Promise<RequestResponse> {
  return request("/study_plan_tasks", { method: "GET" });
}
